import React from 'react';
import configData from "../appconfig/config.json";
import { FormInput, FormComboBox, FormNumericTextBox } from '../core/customComponents';
import { acntNameValidator, tovalidateExpdate, nominatedbankVaild, bankAcntNOValidator, AmountValidator, tenureValidator } from '../core/validationRules';
import FormContainer from './FormContainer';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import toFetchIDValue from '../data/IdTypeCheck';

import banklist from '../data/banklist';
import tenure from '../data/tenure';
import { Button } from '@progress/kendo-react-buttons';

var CryptoJS = require("crypto-js");
let key = CryptoJS.enc.Utf8.parse("8080808080808080");
let iv = CryptoJS.enc.Utf8.parse("8080808080808080");

const DEFAULT_RATES_BY_TENURE = {
    [configData.TENURE1]: { int: configData.INT_RATE1, eft: configData.EFT_RATE1 },
    [configData.TENURE2]: { int: configData.INT_RATE2, eft: configData.EFT_RATE2 },
    [configData.TENURE3]: { int: configData.INT_RATE3, eft: configData.EFT_RATE3 },
    [configData.TENURE4]: { int: configData.INT_RATE4, eft: configData.EFT_RATE4 },
    [configData.TENURE5]: { int: configData.INT_RATE5, eft: configData.EFT_RATE5 }
};

const NEW_RATES_BY_TENURE = {
    [configData.TENURE1]: { int: configData.INT_RATE1new, eft: configData.EFT_RATE1new },
    [configData.TENURE2]: { int: configData.INT_RATE2new, eft: configData.EFT_RATE2new },
    [configData.TENURE3]: { int: configData.INT_RATE3new, eft: configData.EFT_RATE3new },
    [configData.TENURE4]: { int: configData.INT_RATE4new, eft: configData.EFT_RATE4new },
    [configData.TENURE5]: { int: configData.INT_RATE5new, eft: configData.EFT_RATE5new }
};

const CATL1_RATES_BY_TENURE = {
    [configData.TENURE1]: { int: configData.INT_RATE1CATL1, eft: configData.EFT_RATE1CATL1 },
    [configData.TENURE2]: { int: configData.INT_RATE2CATL1, eft: configData.EFT_RATE2CATL1 },
    [configData.TENURE3]: { int: configData.INT_RATE3, eft: configData.EFT_RATE3 },
    [configData.TENURE4]: { int: configData.INT_RATE4, eft: configData.EFT_RATE4 },
    [configData.TENURE5]: { int: configData.INT_RATE5, eft: configData.EFT_RATE5 }
};

const getSelectedRateConfig = (srcParm, selectedTenure) => {
    let selectedRateConfig = DEFAULT_RATES_BY_TENURE[selectedTenure];

    if (srcParm === '' || srcParm === 'CATL3' || srcParm === 'CATL6' || srcParm === 'CATL10' || srcParm === 'CATL11') {
        selectedRateConfig = NEW_RATES_BY_TENURE[selectedTenure] || selectedRateConfig;
    } else if (srcParm === 'CATL1') {
        selectedRateConfig = CATL1_RATES_BY_TENURE[selectedTenure] || selectedRateConfig;
    }

    return selectedRateConfig;
};

class LoanCalculator extends React.Component {
    constructor(props) {
        super(props);
        configData.RefferenceNo = localStorage.getItem('Ref');
        this.onHandleLoanAmountChange = this.onHandleLoanAmountChange.bind(this);

        configData.CrediAbleAcntNo = localStorage.getItem('RefCA');
        this.state = {
            loanTenure: "",
            loanAmount: '',
            nominatedFullName: "",
            nominatedbankAcntNo: "",
            nominatedBank: "",
            srcParm: (localStorage.getItem('srcParm') || '').trim().toUpperCase(),
            monthlyRepayment: "",
            monthlyRepayment: "0.00",
            setTotalRepayment: "0.00",
            responseObj: {}
        }

    }
    componentDidMount() {
        if (tovalidateExpdate(new Date().getMinutes())) {
            if (configData.RefferenceNo) {

                const requestBody = {
                    referenceno: configData.RefferenceNo,
                    num: localStorage.getItem('nricval')
                }

                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Headers': 'Content-Type',
                        'Cache-Control': 'no-cache',//for IE issues
                        'Pragma': 'no-cache',
                        'Authorization': "Maybank" + " " + localStorage.getItem('tkn')
                    },
                    body: JSON.stringify(requestBody)

                };

                fetch(configData.GET_FTDATA, requestOptions)

                    .then(async response => {

                        const data = await response.json();
                        if (!data.didError) {
                            if (data.model.fields) {
                                if (data.model.fields.Fields) {
                                    let res = data.model.fields.Fields.TL;
                                    await this.setState({ loanTenure: res.loanTenure });
                                    await this.setState({ loanAmount: res.loanAmount });
                                    await this.setState({ nominatedFullName: res.nominatedFullName });
                                    await this.setState({ nominatedBank: res.nominatedBank });
                                    await this.setState({ nominatedbankAcntNo: res.nominatedbankAcntNo });
                                    window.scrollTo(0, 0);
                                }
                            }

                        } else {

                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            } else {
                alert("This session has timed out for your security.");
                document.location.href = configData.URL_ToHomeScreen;
                localStorage.clear();
                return false;
            }
        } else {
            alert("This session has timed out for your security.");
            window.location.href = configData.URL_ToHomeScreen
            localStorage.clear();
            return false;
        }


    }


    handleSubmit = (event) => {

        if (localStorage.getItem('mbl')) {
            configData.decryptMbl = CryptoJS.AES.decrypt(localStorage.getItem('mbl'), key, { iv: iv })
            configData.decryptMbl = configData.decryptMbl.toString(CryptoJS.enc.Utf8)
        } else {
            configData.decryptMbl = localStorage.getItem('mbl');
        }

        let effIntstRateVal;
        let intstRateVal;
        const selectedRateConfig = getSelectedRateConfig(this.state.srcParm.toUpperCase(), event.values.loanTenure);

        if (selectedRateConfig) {
            effIntstRateVal = selectedRateConfig.int + " %  p.a.";
            intstRateVal = selectedRateConfig.eft + " %  p.a.";
        }


        const requestBody = {
            TL: {
                fullName: localStorage.getItem('Otp_Name'),//from personal info//to do change to gloabl
                NRICVVal: localStorage.getItem('Otp_nric'),//from personal info//to do change to gloabl
                mobileNo: configData.decryptMbl,//from personal info//to do change to gloabl
                loanAmount: event.values.loanAmount,
                loanTenure: event.values.loanTenure,
                creditAbleAcntNo: configData.CrediAbleAcntNo,//11 digit Acnt No

                nominatedFullName: event.values.nominatedFullName,
                nominatedBank: event.values.nominatedBank,
                nominatedBankID: toFetchIDValue("BANKDATALIST", event.values.nominatedBank),
                nominatedbankAcntNo: event.values.nominatedbankAcntNo,

                interestRate: effIntstRateVal,
                effectiveIntRate: intstRateVal,
                SOURCE_CODE: localStorage.getItem('Otp_Sc'),
                Domain_URI: localStorage.getItem('domainURI')
            }
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Authorization': "Maybank" + " " + localStorage.getItem('tkn')
            },
            body: JSON.stringify(requestBody)

        };

        fetch(configData.URL_SAVE_FT + "?refno=" + configData.RefferenceNo + "&prodtype=" + configData.PRODUCT_TYPE, requestOptions)
            .then(async response => {

                const data = await response.json();

                if (!data.didError) {
                    this.props.history.push('ReviewDetails');
                    window.scrollTo(0, 0);
                } else {
                    alert("Some thing went wrong! please try again")
                }

                // history.push('ReviewDetails')

            })
            .catch(error => {
                alert("Some thing went wrong! please try again");
                document.location.href = configData.URL_ToHomeScreen;
                console.error('There is an error!', error);


            });



    }


    onHandleLoanAmountChange = async (e) => {


    }

    // loanAmount = async (event) => {
    //     console.log(event.target.value);
    //     this.state.loanTenure = "";
    //     this.state.monthlyRepayment = "";
    //     this.state.setTotalRepayment = "";
    //     await this.setState({ loanAmount: event.target.value });

    // }

    loanTenure = async (event) => {
        const selectedTenure = event?.value || event?.target?.value || "";
        await this.setState({ loanTenure: selectedTenure });

    }
    // loanTenure = async (event) => {

    //     if (this.state.loanAmount) {
    //         if (this.state.loanAmount >= 2000) {
    //             let lT;
    //             let IR;
    //             if (event.target.value === configData.TENURE1) {
    //                 lT = configData.LT1;
    //                 IR = configData.INT_RATE1;
    //             }
    //             if (event.target.value === configData.TENURE2) {
    //                 lT = configData.LT2;
    //                 IR = configData.INT_RATE2;
    //             }
    //             if (event.target.value === configData.TENURE3) {
    //                 lT = configData.LT3;
    //                 IR = configData.INT_RATE3;
    //             }
    //             if (event.target.value === configData.TENURE4) {
    //                 lT = configData.LT4;
    //                 IR = configData.INT_RATE4;
    //             }

    //             if (event.target.value === configData.TENURE5) {
    //                 lT = configData.LT5;
    //                 IR = configData.INT_RATE5;

    //             }

    //             let mul = this.state.loanAmount * (IR / 100);
    //             let first = (mul * lT / 12);//LT

    //             let add = ((+first) + (+this.state.loanAmount));
    //             let result = (add / lT).toFixed(2);//LT
    //             this.state.monthlyRepayment = result;
    //             let setprocessingPayment = (this.state.loanAmount * (2 / 100))
    //             let setTotalRepayment = result * lT
    //             this.state.setTotalRepayment = setTotalRepayment.toFixed(2);

    //         } else {
    //             this.state.loanTenure = "";
    //             this.state.monthlyRepayment = "";
    //             this.state.setTotalRepayment = "";
    //             console.log('The amount transferred cannot be less than S$2000');
    //         }


    //     }
    //     console.log(event.target.value);
    //     await this.setState({ loanTenure: event.target.value });

    //     if (!event.target.value) {
    //         this.state.monthlyRepayment = "";
    //         this.state.setTotalRepayment = "";
    //     }
    // }

    render() {
        const srcParm = (this.state.srcParm || '').toUpperCase();
        const selectedRateConfig = getSelectedRateConfig(srcParm, this.state.loanTenure);
        return (
            <div className="container-fluid">

                <div className='row'>
                    <div className="container mt-5">
                        <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
                    </div>


                    <div className="demo-section k-content dynmicwhitecntr  DynamicFields">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="row example-wrapper">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="card-block">

                                        <Form
                                            initialValues={this.state}
                                            key={JSON.stringify(this.state)}
                                            onSubmitClick={this.handleSubmit}
                                            render={(formRenderProps) => (
                                                <FormElement>

                                                    <fieldset className={'k-form-fieldset'}>
                                                        <div className="row around-xs inputPairelementVisible" style={{ marginTop: "1.5rem" }}>
                                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                                {/* <legend className={'k-form-legend'}>{configData.HDR_LC_DETAILS}</legend> */}
                                                            </div>
                                                        </div>

                                                    </fieldset>
                                                    <h2>Application Details</h2>

                                                    <fieldset>
                                                        <p>Note: Maximum approved loan amount will be at 90% of the available credit limit during time of processing.</p>
                                                        
                                                        {(srcParm === 'CATL13') && (
                                                            <p><b>
                                                            *For a limited period, be rewarded with an automatic Arbutus timepiece worth S$450 with a minimum loan of S$7,000 and tenure of 24 months or more. T&Cs apply.* 
                                                            </b>
                                                            </p>
                                                        )}
                                                        
                                                        {(srcParm === 'CATL12') && (
                                                            <p><b>
                                                            *For a limited period, enjoy up to 2% cashback with a minimum loan of S$10,000 and tenure of 36 months or more. T&Cs apply.* 
                                                            </b>
                                                            </p>
                                                        )}
                                                        {/* <p>Calculate your estimated monthly repayment based on your preferred loan amount and tenure.</p> */}
                                                    </fieldset>
                                                    <Field
                                                        id={"loanAmount"}
                                                        name={'loanAmount'}
                                                        label={'Loan Amount (S$)'}
                                                        placeholder={"Minimum S$ 1000"}
                                                        component={FormInput}
                                                        onChange={this.onHandleLoanAmountChange}
                                                        // onChange={this.loanAmount}
                                                        validator={AmountValidator}
                                                    />







                                                    <Field

                                                        label={'Loan Repayment Period'}
                                                        component={FormComboBox}

                                                        key={'loanTenure'}
                                                        id={'loanTenure'}
                                                        name={'loanTenure'}
                                                        placeholder={'Please Select'}
                                                        onChange={this.loanTenure}
                                                        data={tenure}
                                                        validator={tenureValidator}
                                                        value={this.state.loanTenure}
                                                    />



                                                    <br></br>
                                                    {/* 
    <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div className="box"><label className="k-label">
                Loan Amount (S$)</label>
                <br></br>
                <div className="k-form-field-wrap">
                    <input style={{ width: "100 %", padding: "7px" }}

                        placeholder={"Minimum S$ 2000"}
                        type={"number"}
                        id={"loanAmount"} name={'loanAmount'}
                        onChange={this.loanAmount}
                        validator={this.requiredValidator}
                    />
                </div>
            </div>
        </div>

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">

            <div className="box"><label className="k-label">
                Loan Repayment Period</label>
                <br></br>
                <div className="k-form-field-wrap">
                    <ComboBox
                        key={'loanTenure'}
                        id={'loanTenure'}
                        name={'loanTenure'}
                        placeholder={'Please Select'}
                        onChange={this.loanTenure}
                        data={tenure}
                        validator={requiredValidator}
                        value={this.state.loanTenure}
                    />
                </div>
            </div>
        </div>
    </div>
*/}

                                                    <legend className={'k-form-legend'}></legend>

                                                    <fieldset>
                                                        {/* <PayBillsView /> */}
                                                        <div className="row around-xs inputPair elementVisible">
                                                            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                                                <div className="box">
                                                                    {/* <label   className="k-label">
                    Monthly repayment</label>
                    <br></br>
                    <div className="k-form-field-wrap">
                        <label   className="k-label" >
                            <span className="smallContent">{configData.SING_DOLR}</span>
                            <p className="lrgContent"> {this.state.monthlyRepayment}</p></label>
                    </div>*/}
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">

                        <div className="box"><label className="k-label">
                            Interest Rate</label>
                            <br></br>
                            <div className="k-form-field-wrap">
                                {selectedRateConfig && <label className="k-label" >
                                    <p className="lrgContent"> {selectedRateConfig.int}</p>
                                    <span className="smallContent">{configData.P_A}</span>
                                </label>}


                            </div>
                        </div>
                    </div>
                </div>



                                                        <div className="row around-xs inputPair elementVisible">
                                                            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                                                {/* <div className="box"><label   className="k-label">
                    Total repayment</label>
                    <br></br>
                    <div className="k-form-field-wrap">
                        <label   className="k-label" >
                            <span className="smallContent">{configData.SING_DOLR}</span>
                            <p className="lrgContent"> {this.state.setTotalRepayment}</p></label>
                    </div>
                </div> */}
                </div>

                <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">

                    <div className="box"><label className="k-label">
                        Effective Interest Rate</label>
                        <br></br>
                        <div className="k-form-field-wrap">
                            {selectedRateConfig && <label className="k-label" >
                                <p className="lrgContent"> {selectedRateConfig.eft}</p>
                                <span className="smallContent">{configData.P_A}</span>
                            </label>}


                        </div>
                    </div>
                </div>
            </div>




                                                    </fieldset>
                                                    <br></br><br></br>
                                                    <h2>Nominated Bank Details</h2>
                                                    <fieldset className={'k-form-fieldset'}>
                                                        <div className="row around-xs inputPairelementVisible">
                                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                                <legend className={'k-form-legend'}>{"CreditAble Term Loan Application"}</legend>
                                                            </div>
                                                        </div>
                                                    </fieldset>






                                                    <Field id={'nominatedFullName'}
                                                        name={'nominatedFullName'}
                                                        label={'Name as per your Nominated Bank Account (Belonging to CreditAble Applicant)'}
                                                        placeholder={'Full Name in NRIC/Passport'}
                                                        component={FormInput}
                                                        validator={acntNameValidator}
                                                    />
                                                    <Field
                                                        key={'nominatedBank'}
                                                        id={'nominatedBank'}
                                                        name={'nominatedBank'}
                                                        label={'Nominated Bank (Please specify a non-Maybank Account)'}
                                                        component={FormComboBox}
                                                        data={banklist}
                                                        value={this.state.selectedBank}
                                                        validator={nominatedbankVaild}

                                                    />


                                                    <Field id={'nominatedbankAcntNo'} name={'nominatedbankAcntNo'} label={'Nominated Bank Account No.'} placeholder={'Please fill Bank Account No.'} component={FormInput} validator={bankAcntNOValidator} />
                                                    <div className="text-right" style={{ marginTop: "2rem" }}>
                                                        <Button className="btnMaybank"
                                                            primary={true}
                                                            type={'submit'}
                                                            disabled={!formRenderProps.valid}>{configData.ON_NEXT}</Button>

                                                    </div>

                                                    <br></br>


                                                </FormElement>
                                            )} /></div></div></div></div></div>


                </div>
            </div>
        )
    }
}


export default LoanCalculator;

